import { render, staticRenderFns } from "./ConfirmDeleteCertificateForm.vue?vue&type=template&id=650208a4"
import script from "./ConfirmDeleteCertificateForm.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteCertificateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports